import type { PortalKey } from '@/api/client';

export const PORTAL_COPY: Record<PortalKey, { name: string; tagline: string; loginHint: string; accounts: string }> = {
  skyrun: {
    name: 'SkyRun HQ',
    tagline: 'Franchise rollout and performance, powered by Besty',
    loginHint: 'Access is granted per person. Sign in with your @skyrun.com account.',
    accounts: 'SkyRun',
  },
  stayterra: {
    name: 'StayTerra HQ',
    tagline: 'Rollout and upsell performance across StayTerra, powered by Besty',
    loginHint: 'Sign in with your @stayterravaca.com Google account.',
    accounts: 'StayTerra',
  },
  elevated: {
    name: 'Elevated Hospitality HQ',
    tagline: 'Rollout and upsell performance across Elevated Hospitality, powered by Besty',
    loginHint: 'Sign in with your @elevatedhospitalitypartners.com Google account.',
    accounts: 'Elevated Hospitality',
  },
};

export function portalFromPath(pathname: string): PortalKey | null {
  const key = pathname.replace(/^\/+|\/+$/g, '');
  if (key === '' || key === 'login') return 'skyrun';
  return key === 'stayterra' || key === 'elevated' ? key : null;
}

export function pathForPortal(key: PortalKey): string {
  return key === 'skyrun' ? '/' : `/${key}`;
}
